








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { Location } from '../../models/userdata/Location';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyProfileDetails',
  components: {
    Datepicker,
    VueGoogleAutocomplete,
  },
})
export default class MultipleLocationDetails extends Vue {
  $refs!: {
    address: any;
  };
  private locations: Location[] = [];
  // private address: String = '';
  // private locationAddress: String = '';
  // private addLocations: Location[] = [];
  // public desiredLocation: string[] = [];

  // @Watch('locations')
  // selectedlocationlist(val) {
  //   this.locations = val;
  // }

  // mounted() {
  //   this.addLocations = this.userProfile.desiredLocations;
  //   this.locations = this.userProfile.desiredLocations;
  // }

  get userProfile() {
    return vxm.users.myUserProfile;
  }

  getAddressData(addressData, placeResultData, id) {
    let selectedLocationObject: Location = new Location();
    selectedLocationObject.locationAddress = placeResultData.formatted_address;
    selectedLocationObject.latitude = addressData.latitude;
    selectedLocationObject.longitude = addressData.longitude;
    selectedLocationObject.city =
      placeResultData.address_components[0].long_name;
    selectedLocationObject.state = addressData.administrative_area_level_1;
    selectedLocationObject.country = addressData.country;
    this.userProfile.desiredLocations.push(selectedLocationObject);
    // this.getDesiredLocation();
    this.$refs.address.$el.value = '';
  }

  locationText(location) {
    if (!location.state) {
      return location.city;
    }
    return location.city + ',' + location.state.toUpperCase();
  }

  removeLocation(index) {
    this.userProfile.desiredLocations.splice(index, 1);
    // console.log('Remove');
    // this.locations.splice(index, 1);
    // this.userProfile.desiredLocations = this.addLocations;
    // this.getDesiredLocation();
  }
  getDesiredLocation() {
    // this.userProfile.desiredLocationString = '';
    // for (let index = 0; index < this.locations.length; index++) {
    //   this.userProfile.desiredLocationString = this.userProfile.desiredLocationString
    //     .concat(this.locations[index].city)
    //     .concat(',')
    //     .concat(this.locations[index].state)
    //     .concat(',')
    //     .concat('  ');
    // }
  }
}
